<template>
  <div class="u-wrapper-panel u-pointer-none">
    <app-image v-if="data.avLogo.length" :width="300" :id="data.avLogo[0].id" class="scene-logo" :class="{'scene-logo--right': data.avLogoPosition === 'right'}" />
    <screen
      :idYoutube="data.avYoutube"
      :idVimeo="data.avVimeo"
      :video="data.video && data.video.length ? data.video[0].url : ''"
      @currentTime="onCurrentTime"
      @play="onPlay"
      @pause="onPause"
      :position="screenPosition"
    />
    <transition name="t-fader">
      <app-legend
        v-for="(datum, index) in dataObjects"
        v-if="index === currentInfo"
        :key="index"
        :title="datum.titre"
        :text="datum.description"
        :subtitle="datum.subtitle"
        :position="legendPosition[index]"
        :isTracking="data.avTracking"
        :cta="{color: datum.ctaColor, link: datum.ctaLink, label: datum.ctaText}"
      />
    </transition>
    <div @click="onClick" class="u-wrapper-panel u-cursor-pointer" :class="{'u-pointer-all': isOverIndex !== -1}" />
  </div>
</template>

<script>
import Screen from '@/components/3D/Screen'
import AppLegend from '@/components/AppLegend'

import { Timeline } from '@/utils/TimelineVideo'
import { FitTo } from '@/utils/FitTo'
import { mapper, toScreenPosition } from '@/utils/Maths'

import { BaseObject } from '@/webGL/objects/BaseObject'
import { Scenery } from '@/webGL/objects/Scenery'
import { webGL } from '@/webGL/WebGL'

import objectsData from '@/assets/data/objects'
import staticData from '@/assets/data/staticData'


import { Vector3, Box3 } from 'three'

export default {
  data () {
    return {
      screenPosition: { x: 0, y: 35, z: 15 },
      isOverIndex: -1,
      currentInfo: -1,
      legendPosition: []
    }
  },

  components: {
    Screen,
    AppLegend
  },

  computed: {
    data () {
      return this.$store.getters['data/entry']
    },
    dataObjects () {
      return this.$store.getters['data/objects']
    },
  },

  created () {
    this.timeline = new Timeline(this.onEvent)

    const timecodes = []
    // TRANSFORM TC APPEARANCE AND DISAPEARANCE
    //  FROM OBJECTS TO TIMELINE DATA
    this.dataObjects.forEach((datum, index) => {
      if (datum.timeAppearance !== '') {
        timecodes.push({
          timecode: datum.timeAppearance,
          event: 'fadein',
          index: index
        })
      }
      if (datum.timeDisappearance !== '') {
        timecodes.push({
          timecode: datum.timeDisappearance,
          event: 'fadeout',
          index: index
        })
      }
    })
    this.timeline.setData(timecodes)

    this.fitTo = new FitTo(webGL.camera)

    this.objects = []
    this.onResize()
  },

  mounted () {
    this.scenery = new Scenery('/objects/scenery.glb')
    webGL.scene.add(this.scenery)
    this.addObjects()

    this.$hub.on('click', this.onClick)
  },

  methods: {
    onResize () {
      const box = new Box3(
        new Vector3(this.screenPosition.x - (100 * .5), this.screenPosition.y - (56.2 * .5), this.screenPosition.z),
        new Vector3(this.screenPosition.x + (100 * .5), this.screenPosition.y + (56.2 * .5), this.screenPosition.z)
      )

      const { position, look } = this.fitTo.fit(box, .5, {vector: new Vector3(0, 0, 1)})

      this.objects.forEach((object, index) => {
        const pos = toScreenPosition(object.basePosition, webGL.camera, this.$device.width, this.$device.height)

        this.$set(this.legendPosition, index, pos)
      })

      webGL.camera.position.copy(position)
      webGL.camera.look.copy(look)
    },
    onEvent (event) {
      if (this.objects[event.index]) {
        if (event.event === 'fadein') {
          this.objects[event.index].isVisible = true
        }
        if (event.event === 'fadeout') {
          this.objects[event.index].isVisible = false
        }
      }
    },
    async addObjects () {
      this.dataObjects.forEach((datum, index) => {
        if (!datum.object.length) { return }

        const object = new BaseObject({
          url: datum.object[0].url,
          index: index,
          isFloating: datum.floating,
          rotate: datum.rotation,
          targetScale: mapper(parseFloat(datum.objectSize), 0, 10, .5, 3)
        })
        this.objects.push(object)

        const pos = objectsData.position[datum.objectPosition]
        object.basePosition = new Vector3(pos.x + this.screenPosition.x, pos.y + this.screenPosition.y, pos.z + this.screenPosition.z)

      })

      await Promise.all(this.objects.map(object => object.promise))

      webGL.objectScene.add(...this.objects)

      this.timeline.start()

      this.onResize()
    },
    onUpdate() {
      this.isOverIndex = -1

      for (let i = 0; i < this.objects.length ; i++) {
        const object = this.objects[i]
        if (object.isVisible && this.$device.getIntersectPosition(object.object) !== null) {
          this.isOverIndex = i
          break
        }
      }
    },
    onClick () {
      this.currentInfo = this.isOverIndex
    },
    onCurrentTime (value) {
      this.timeline.onUpdate(value)
    },
    onPlay () {

    },
    onPause () {

    }
  }
}
</script>

<style lang="stylus">
.scene-logo
  position absolute
  bottom 20px
  left 20px
  width 200px
  
  &--right
    left auto
    right 20px
</style>

